import { addMonths } from 'date-fns';
import getDateMonthAndYear from './getDateMonthAndYear';
export default function getNextMonths(months, numberOfMonths, counter, step) {
  let prevMonth;
  const ascending = counter > 0;
  if (step) {
    prevMonth = ascending ? 0 : months.length - step;
  } else {
    prevMonth = ascending ? months.length - 1 : 0;
  }
  let prevMonthDate = months[prevMonth].date;
  return Array.from(Array(numberOfMonths)).reduce(m => {
    if (m.length === 0) {
      prevMonthDate = addMonths(prevMonthDate, counter);
    } else {
      prevMonthDate = addMonths(prevMonthDate, counter >= 0 ? 1 : -1);
    }
    return ascending ? m.concat([getDateMonthAndYear(prevMonthDate)]) : [getDateMonthAndYear(prevMonthDate)].concat(m);
  }, []);
}
//# sourceMappingURL=getNextMonths.js.map